// extracted by mini-css-extract-plugin
module.exports = {"bygqr01":"bygqr01"};